import { useState } from "react";
import {
  Banner,
  BannerTypes,
  Button,
  Modal,
  tokens,
  Typography,
} from "@sunrun/experience-ui-components";
import { useFlags } from "flagsmith/react";
import { FeatureFlags } from "fixtures/features";

const MaintenanceBanner = () => {
  const [viewModal, setViewModal] = useState(false);

  const flags = useFlags([FeatureFlags.PAYMENT_OUTAGE]);

  // Default to true if the flag is undefined
  const showBanner = flags[FeatureFlags.PAYMENT_OUTAGE]?.enabled ?? true;

  return (
    <>
      {showBanner ? (
        <Banner
          title="Scheduled payment system maintenance: payment & billing currently unavailable."
          bannerType={BannerTypes.InfoLight}
          show={true}
          showClose={false}
          showIcon={true}
          style={{ zIndex: 2 }}
          customButtons={
            <Button
              color="link"
              size="sm"
              style={{
                color: tokens.INFO_20,
                textDecorationColor: tokens.INFO_20,
              }}
              onClick={() => {
                setViewModal(true);
              }}
            >
              Learn More
            </Button>
          }
        />
      ) : null}
      {viewModal && (
        <Modal
          testId="scheduled-billing-maintenance-modal"
          onClose={() => setViewModal(false)}
          title="Scheduled Billing Maintenance"
          primaryButton={{
            text: "Got it",
            onClick: () => setViewModal(false),
          }}
        >
          <div>
            <Typography>
              As part of scheduled maintenance, billing (including autopay
              changes) is currently unavailable. This includes access via the
              app, http://my.sunrun.com, or through our phone support.
            </Typography>
            <Typography>Thank you for your patience!</Typography>
          </div>
        </Modal>
      )}
    </>
  );
};

export { MaintenanceBanner };
